import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface GoogleReview {
  author_name: string;
  author_photo: string;
  author_initials: string;
  rating: number;
  text: string;
  time: string;
  relative_time_description: string;
}

export interface GoogleReviewsResponse {
  reviews: GoogleReview[];
  rating: number;
  total_ratings: number;
  place_name: string;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleReviewsService {
  // Use environment variable or localhost for development
  private apiUrl = `${environment.apiUrl}/api/google-places`;

  constructor(private http: HttpClient) {}

  getReviews(): Observable<GoogleReviewsResponse> {
    return this.http.get<GoogleReviewsResponse>(`${this.apiUrl}/reviews`);
  }
}